<template>
  <div>
    <svg v-if="!loaded" class="spinner" viewBox="0 0 50 50">
      <circle
        class="path"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke-width="5"
      ></circle>
    </svg>
    <template v-else>
      <div
        v-if="content && !active"
        class="content"
        :style="{
          marginLeft: `${2 + level * 2}rem`,
        }"
        v-html="content"
      />
      <div v-for="child in children" :key="child.id">
        <div
          class="head"
          :class="{ active: active == child }"
          :style="{
            paddingLeft: `${2.3 + level * 2}rem`,
          }"
          @click="toggle(child)"
        >
          {{ child.title }}
          <span>&gt;</span>
        </div>
        <report-section
          v-if="active == child"
          :id="child.id"
          :level="level + 1"
        />
      </div>
    </template>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  name: 'ReportSection',
  props: {
    id: {
      type: Number,
      required: true
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    loaded: false,
    active: null,
    children: [],
    content: null
  }),
  computed: {
    ...mapGetters(['url', 'year'])
  },
  created () {
    axios
      .get(`${this.url}/${this.year}/categories/${this.id}`, {
        headers: {
          'Accept-Language': this.$route.params.locale
        }
      })
      .then(({ data }) => {
        this.children = data.children
        this.content = data.content
        this.$nextTick(() => {
          this.loaded = true
        })
      })
  },
  methods: {
    toggle (child) {
      const active = this.active !== child ? child : null
      this.active = active
      if (active) {
        window.scrollTo(0, this.$el.offsetTop - 40)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content /deep/ {
  margin-right: 2.6rem;
  font-size: 0.94rem;
  p {
    margin-top: 0;
    margin-bottom: 0.4rem;
  }
  img {
    margin-bottom: 0.7rem;
  }
  table {
    border-collapse: collapse;
    width: 100%;
    td,
    th {
      border: 1px solid black;
      padding: 0.2rem 0.5rem;
      p {
        margin: 0;
        padding: 0;
      }
    }
  }
}
.content:after {
  content: "";
  display: block;
  clear: both;
}
.head {
  display: block;
  position: relative;
  background: #bcbec0;
  margin-bottom: 0.3vw;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.1rem;
  text-decoration: none;
  color: #414042;
  box-sizing: border-box;
  width: 100%;
  padding-left: 2.3rem;
  cursor: pointer;
  user-select: none;
  span {
    display: block;
    position: absolute;
    top: 0;
    right: 1.3rem;
    width: 2rem;
    height: 2rem;
    line-height: 2rem;
    background-color: #414042;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%22-5%20-5%2035.141%2032.908%22%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M0%2022.908V0l25.141%2011.454z%22%2F%3E%3C%2Fsvg%3E");
    background-size: 1.6rem 2rem;
    background-repeat: no-repeat;
    background-position: center center;
    z-index: 999999;
    text-indent: -9999px;
  }
  &:hover {
    background-color: #e41e2b;
    color: white;
    span {
      background-color: #e41e2b;
    }
  }
  &.active {
    font-weight: 600;
    span {
      background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%22-5%20-5%2035.141%2032.908%22%3E%3Cpath%20transform%3D%22scale%28-1%2C1%29%20translate%28-23.141%2C%200%29%22%20fill%3D%22%23FFF%22%20d%3D%22M0%2022.908V0l25.141%2011.454z%22%2F%3E%3C%2Fsvg%3E");
      background-color: #e41e2b;
    }
  }
}
</style>
